import { LinkWithAnalyticsGlobalField } from "@/types";
import Glossary from "./Glossary";

export type GlossaryEntry = {
  index: string;
  headline: LinkWithAnalyticsGlobalField;
  description: string;
  solution: LinkWithAnalyticsGlobalField;
};

export type GlossaryTableHeaders = {
  firstColumn: string;
  secondColumn: string;
  thirdColumn: string;
};

export interface ItGlossaryProps {
  glossaryEntries: GlossaryEntry[];
  glossaryTableHeaders: GlossaryTableHeaders;
}

const ItGlossary = ({
  glossaryTableHeaders,
  glossaryEntries = [],
}: ItGlossaryProps) => {
  return (
    <Glossary tableHeaders={glossaryTableHeaders} entries={glossaryEntries} />
  );
};

export default ItGlossary;
